export default __webpack_public_path__ + "static/capterra-29c89ad60fdaf2b02e9418b270e60994.svg";